module.exports = __webpack_public_path__ + "static/bg-f013a9ebef8f2b60db65b2c430c6839f.png";